// extracted by mini-css-extract-plugin
export default {"banner":"RouterBanner_banner__jt5p7","content":"RouterBanner_content__BD7Ui","text":"RouterBanner_text__ju42z"};